import type { IconSvgObject } from './types';

const MicrochipIcon: IconSvgObject = [
  ["path", { d: "M6 15V9C6 6.17157 6 4.75736 6.87868 3.87868C7.75736 3 9.17157 3 12 3C14.8284 3 16.2426 3 17.1213 3.87868C18 4.75736 18 6.17157 18 9V15C18 17.8284 18 19.2426 17.1213 20.1213C16.2426 21 14.8284 21 12 21C9.17157 21 7.75736 21 6.87868 20.1213C6 19.2426 6 17.8284 6 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 12H20M18 6H20M18 18H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 12H6M4 6H6M4 18H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 12H14M10 7H14M10 17H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MicrochipIcon;
